<template>
  <a-modal
    v-model:visible="logVisible"
    title="日志"
    :footer="null"
    :width="800"
  >
    <a-table
      :dataSource="logData"
      :columns="logColumns"
      :pagination="false"
      :scroll="{ y: 390 }"
      size="small"
    >
      <template #bodyCell="{ column, index }">
        <template v-if="column.key === 'no'">
          {{ index + 1 }}
        </template>
      </template>
    </a-table>
  </a-modal>
  <div class="collection-container">
    <FourElement />
  </div>
  <div class="collection-container">
    <Filter />
    <div style="height: 30px;"></div>
    <Table />
    <Drawer />
  </div>
</template>
<script>
import {
  defineComponent,
  provide,
  reactive,
  toRefs,
  watch,
  onMounted,
  h
} from 'vue'
import {
  addressValidate_countryList_get,
  addressValidate_detail_get,
  addressValidate_edit_post
} from './../../server/modules/9022'
import {
  abtest_new_queryLog_get,
  abtest_new_remove_get
} from '@/server/modules/91176'
import { common_querySiteInfo_get } from './../../server/modules/3426'
import {
  abtest_new_list_post,
  abtest_new_modifystatus_post,
  abtest_new_save_post,
  abtest_new_query_get
} from './../../server/modules/91176'
import { common_listLanguageInfo_get } from './../../server/modules/7767'
import Filter from './components/filter.vue'
import Table from './components/table.vue'
import Drawer from './components/drawer.vue'
import { message, notification } from 'ant-design-vue'
import { AB_TEST_TYPES } from './ruleData'
import {
  ruleData,
  TEST,
  RUNNING,
  END,
  PAUSED,
  DRAFT,
  PUBLISED,
  statusOptionList
} from './ruleData'
import FourElement from './components/FourElement.vue'
import { useRouter, useRoute } from 'vue-router'
import { post_abLayer_new_queryAll } from '@/server/modules/21934'
import { post_abDevice_queryAll } from '@/server/modules/21937'

export default defineComponent({
  name: 'AddressRule',
  components: { Filter, Table, Drawer, FourElement },
  setup() {
    const router = useRouter()
    const customCell = record => {
      return {
        onClick: () => {
          if (record.status === END) {
            router.push({
              path: '/ABtestLabV3',
              query: {
                id: record.id,
                isCopy: 0,
                isReport: 0,
                testType: state.testType
              }
            })
          }
        }
      }
    }
    const state = reactive({
      AB_TEST_TYPES,
      TEST,
      RUNNING,
      END,
      PAUSED,
      DRAFT,
      PUBLISED,
      testType: 0,
      typeModalVisible: false,
      deviceDrawerVisible: false,
      deviceList: [],
      choosedDeviceList: [],
      isEdit: false,
      alreadySelectLanguage: {},
      languageOptionList: [],
      layerList: null,
      deviceVisible: false,
      drawerInfo: {},
      drawerTitle: '',
      drawerVisible: false,
      logVisible: false,
      logData: [],
      logColumns: [
        {
          title: 'ID',
          dataIndex: 'no',
          key: 'no',
          width: 40,
          align: 'center'
        },
        {
          title: '操作人',
          dataIndex: 'operateUser',
          key: 'operateUser',
          width: 160,
          align: 'center'
        },
        {
          title: '操作内容',
          dataIndex: 'operateContent',
          key: 'operateContent'
        },
        {
          title: '操作时间',
          dataIndex: 'operateTime',
          key: 'operateTime',
          width: 180
        }
      ],
      searchParams: {
        brandId: 1,
        channelId: 1,
        siteId: 1,
        terminalId: 1
      },
      searchForm: {
        type: null,
        layerId: null,
        userName: null,
        status: null,
        id: null,
        name: null,
        countryIds: [],
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pages: 0
      },
      countryOptionList: [],
      statusOptionList,
      dataSource: [],
      columns: [
        {
          customCell,
          title: 'ID',
          dataIndex: 'no',
          key: 'no',
          align: 'center'
        },
        {
          customCell,
          title: '实验名称',
          dataIndex: 'name',
          key: 'name',
          width: 200,
          align: 'center'
        },
        {
          customCell,
          title: '实验层分组',
          dataIndex: 'layerName',
          key: 'layerName',
          align: 'center'
        },
        {
          customCell,
          title: '实验类型',
          dataIndex: 'type',
          key: 'type',
          align: 'center'
        },
        {
          customCell,
          title: '实验状态',
          dataIndex: 'status',
          key: 'status',
          align: 'center'
        },
        {
          customCell,
          title: '运行时长',
          dataIndex: 'runTime',
          key: 'runTime',
          align: 'center'
        },
        {
          customCell,
          title: '运行周期',
          dataIndex: 'runRange',
          key: 'runRange',
          align: 'runRange'
        },
        {
          customCell,
          title: '创建人/创建时间',
          dataIndex: 'lastUpdateTime',
          key: 'lastUpdateTime',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          key: 'action',
          width: 450,
          align: 'center'
        }
      ],
      checkAll: false,
      yindeterminate: false,
      brands: [],
      channels: [],
      sites: [],
      detailData: [],
      openDeviceDrawer(id) {
        state.deviceDrawerVisible = true
        state.queryDetailInfo(id)
      },
      publishVisibleChange(visible, id) {
        visible && state.queryDetailInfo(id)
      },
      queryDetailInfo: async baseId => {
        const { success, data } = await abtest_new_query_get({ baseId })
        if (success) {
          data.variants.forEach(item => {
            item.deviceIds = item.deviceIds || []
          })
          state.detailData = data
        }
      },
      async saveVariants() {
        // if (
        //   state.detailData.variants.find(item => item.deviceIds.length === 0)
        // ) {
        //   message.error('请选择设备')
        //   return
        // }
        const { success, retInfo } = await abtest_new_save_post(
          state.detailData
        )
        if (success) {
          message.success('保存成功')
          state.deviceDrawerVisible = false
        } else {
          message.error(retInfo)
        }
      },
      getSiteInfo: async () => {
        const { data } = await common_querySiteInfo_get()
        state.brands = data[1]
        state.channels = data[2]
        state.sites = data[3]
      },
      filterOption: (input, option) => {
        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      onChangeAll: () => {
        state.searchForm.countryIds = state.countryOptionList.map(i => i.value)
      },
      onCheckAllChange: () => {
        if (state.checkAll) {
          state.searchForm.countryIds = state.countryOptionList.map(
            i => i.value
          )
        } else {
          state.searchForm.countryIds = []
        }
      },
      reverse: () => {
        const reverseCountry = []
        state.countryOptionList.forEach(i => {
          if (state.searchForm.countryIds.indexOf(i.value) < 0) {
            reverseCountry.push(i.value)
          }
        })
        state.searchForm.countryIds = reverseCountry
      },
      getCountryList: async () => {
        const { success, data } = await addressValidate_countryList_get()
        if (success) {
          state.countryOptionList = data.map(i => {
            return {
              label: i.countryCode
                ? `[${i.countryCode}]${i.countryName}`
                : i.countryName,
              value: i.countryId
            }
          })
        }
      },
      terminalIdChange() {
        state.testType = 0
        state.getTableList()
      },
      getTableList: async () => {
        const { data } = await abtest_new_list_post({
          ...state.searchParams,
          id: state.searchForm.id,
          name: state.searchForm.name || null,
          status: state.searchForm.status,
          type: state.searchForm.type,
          current: state.searchForm.pageNum,
          userName: state.searchForm.userName,
          layerId: state.searchForm.layerId,
          size: state.searchForm.pageSize,
          startTime: null,
          endTime: null
        })
        state.searchForm.pageNum = data.current
        state.searchForm.pageSize = data.size
        state.searchForm.total = data.total
        state.searchForm.pages = data.pages
        for (let i = 0; i < data.records.length; i++) {
          // data.records[i].startTime =
          //   data.records[i].startTime + '至' + data.records[i].endTime
          // data.records[i].type =
          //   data.records[i].type === 0 ? '实验类型1' : '实验类型2'
        }
        state.dataSource = data.records
      },
      getDeviceList: async () => {
        const { success, data } = await post_abDevice_queryAll({})
        if (success) {
          state.deviceList = data.map(item => ({
            label: item.name + ':' + item.distinctId,
            value: item.id
          }))
        }
      },
      changeStatus: async baseId => {
        const { success } = await abtest_new_remove_get({
          baseId
        })
        if (success) {
          message.success('删除成功')
          state.searchForm.pageNum = 1
          state.getTableList()
        } else {
          message.error('删除失败，请稍后重试')
        }
      },
      onlineTime: null,
      onlineMethod: 0,
      modifyVariantId: null,
      lineConfirm: async (record, type) => {
        if (
          type === 'online' &&
          state.onlineMethod === 1 &&
          !state.onlineTime
        ) {
          message.error('请选择运行时间')
          return
        }
        const { success, retInfo } = await abtest_new_modifystatus_post({
          baseId: record.id,
          status: type === 'online' ? RUNNING : PUBLISED,
          onlineMethod:
            type !== 'online' || record.status === PAUSED
              ? null
              : state.onlineMethod,
          variantId: type === 'publish' ? state.modifyVariantId : null,
          onlineTime:
            type === 'online'
              ? state.onlineMethod === 1
                ? state.onlineTime.format('YYYY-MM-DD HH:mm:ss')
                : null
              : null
        })
        if (success) {
          message.success(retInfo)
          state.getTableList()
        } else {
          message.error(retInfo)
        }
      },
      offlineConfirm: async baseId => {
        const { success, retInfo } = await abtest_new_modifystatus_post({
          baseId,
          status: END
        })
        if (success) {
          message.success(retInfo)
          state.getTableList()
        } else {
          message.error(retInfo)
        }
      },
      stop: async baseId => {
        const { success, retInfo } = await abtest_new_modifystatus_post({
          baseId,
          status: PAUSED
        })
        if (success) {
          message.success(retInfo)
          state.getTableList()
        } else {
          message.error(retInfo)
        }
      },
      showReport: id => {
        state.isEdit = false
        router.push({
          path: '/ABtestLabV3',
          query: {
            status: state.searchForm.status,
            name: state.searchForm.name,
            id1: state.searchForm.id,
            id,
            isCopy: 0,
            isReport: 1,
            testType: state.testType
          }
        })
      },
      editDrawerInfo: async (id, isCopy) => {
        state.isEdit = false
        router.push({
          path: '/ABtestLabV3',
          query: {
            status: state.searchForm.status,
            name: state.searchForm.name,
            id1: state.searchForm.id,
            id,
            isCopy: isCopy ? 1 : 0,
            isReport: 0,
            testType: state.testType
          }
        })
      },
      newBuild: () => {
        router.push({
          path: '/ABtestLabV3',
          query: {
            ...state.searchParams,
            isReport: 0,
            testType: state.testType
          }
        })
      },
      viewDrawerInfo: (id, isCopy) => {
        state.isEdit = false
        router.push({
          path: '/ABtestLabV3',
          query: {
            status: state.searchForm.status,
            name: state.searchForm.name,
            id1: state.searchForm.id,
            id,
            isCopy: isCopy ? 1 : 0,
            isReport: 0,
            testType: state.testType,
            isView: 1
          }
        })
      },
      changeDrawer: async id => {
        const { success, data } = await addressValidate_detail_get({ id })
        if (success) {
          state.drawerInfo = data
          let resRuleList = []
          if (
            data.addressValidateConfigDetailDTOList &&
            data.addressValidateConfigDetailDTOList.length > 0
          ) {
            data.addressValidateConfigDetailDTOList.forEach(i => {
              if (!i.errorPromptDTOList || i.errorPromptDTOList.length === 0) {
                i.errorPromptDTOList = [
                  {
                    lang: 'English',
                    langCode: 'en-GB',
                    prompt: ''
                  }
                ]
              }
              resRuleList.push(i)
            })
          }
          let localRuleList = ruleData
          let newRuleData = localRuleList.map(i => {
            let value = resRuleList.filter(ii => ii.type === i.type)
            if (value.length === 1) {
              return {
                ...i,
                ...value[0]
              }
            } else {
              return {
                ...i
              }
            }
          })
          state.drawerInfo.addressValidateConfigDetailDTOList = newRuleData
          state.drawerVisible = true
          state.drawerTitle = '编辑'
        } else {
          message.error('获取详情失败')
        }
      },
      onPageChange: (page, pageSize) => {
        if (pageSize !== state.searchForm.pageSize) {
          state.searchForm.pageNum = 1
        } else {
          state.searchForm.pageNum = page
        }
        state.searchForm.pageSize = pageSize
        state.getTableList()
      },
      searchFormData: () => {
        state.searchForm.pageNum = 1
        state.searchForm.pageSize = 20
        state.getTableList()
      },
      resetFormData: () => {
        state.searchForm = {
          countryIds: [],
          userName: null,
          status: null,
          layerId: null,
          type: null,
          pageNum: 1,
          pageSize: 20,
          total: 0,
          pages: 0
        }
        state.getTableList()
      },
      showLogModal: async id => {
        const { success, data } = await abtest_new_queryLog_get({ baseId: id })
        if (success) {
          state.logData = data
          state.logVisible = true
        }
      },
      getLanguage: async () => {
        const { success, data } = await common_listLanguageInfo_get()
        if (success) {
          state.languageOptionList = data.map(i => {
            return {
              label: i.lang,
              value: i.langCode
            }
          })
        }
      },
      addLanguageItem: index => {
        state.drawerInfo.addressValidateConfigDetailDTOList[
          index
        ].errorPromptDTOList.push({
          langCode: '',
          prompt: ''
        })
      },
      removeLabguageItem: (index, idx) => {
        state.drawerInfo.addressValidateConfigDetailDTOList[
          index
        ].errorPromptDTOList.splice(idx, 1)
      },
      cnacelRequired: index => {
        state.drawerInfo.addressValidateConfigDetailDTOList[
          index
        ].required = null
      },
      submitRules: async () => {
        let englishTipsList = []
        let newAddressValidateConfigDetailDTOList = []
        const pushRuleConfig = (i, index) => {
          if (
            i.required === true ||
            i.required === false ||
            i.appRegularExpression ||
            i.regularExpression ||
            i.webRegularExpression
          ) {
            newAddressValidateConfigDetailDTOList.push(i)
            i.errorPromptDTOList.forEach(ii => {
              if (ii.langCode === 'en-GB' && ii.prompt === '') {
                if (!(i.isShow && !i.showFlag)) {
                  englishTipsList.push(`处理规则${index + 1}的英文提示文案必填`)
                }
              }
            })
          } else if (i.showFlag === true) {
            newAddressValidateConfigDetailDTOList.push(i)
          }
        }
        state.drawerInfo.addressValidateConfigDetailDTOList.forEach(
          (i, index) => {
            if (i.isShow) {
              if (i.showFlag === false) {
                newAddressValidateConfigDetailDTOList.push(i)
              } else if (i.showFlag === true) {
                pushRuleConfig(i, index)
              }
            } else {
              pushRuleConfig(i, index)
            }
          }
        )
        if (englishTipsList.length > 0) {
          notification.error({
            message: '英文提示文案为空',
            description: h('div', {}, [
              h(
                'div',
                englishTipsList.map(item => h('p', `${item}`))
              )
            ])
          })
          return
        }
        let params = state.drawerInfo
        newAddressValidateConfigDetailDTOList.forEach(i => {
          let newDTOList = i.errorPromptDTOList.filter(
            ii => ii.langCode && ii.prompt
          )
          i.errorPromptDTOList = newDTOList
        })
        params.addressValidateConfigDetailDTOList = newAddressValidateConfigDetailDTOList
        const { success } = await addressValidate_edit_post(params)
        if (success) {
          message.success('编辑地址策略成功')
          state.drawerVisible = false
          state.getTableList()
        } else {
          message.error('编辑地址策略失败，请稍后重试')
        }
      }
    })
    async function getLayerList() {
      const { success, data } = await post_abLayer_new_queryAll(
        state.searchParams
      )
      if (success) {
        state.layerList = data.map(item => ({
          label: item.name,
          value: item.id
        }))
      }
    }
    watch(state.searchForm, newVal => {
      let countryIds = newVal.countryIds
      if (countryIds.length === 0) {
        state.checkAll = false
        state.yindeterminate = false
      } else if (
        countryIds.length === state.countryOptionList.length &&
        countryIds.length !== 0
      ) {
        state.checkAll = true
        state.yindeterminate = false
      } else if (
        countryIds.length < state.countryOptionList.length &&
        countryIds.length > 0
      ) {
        state.checkAll = false
        state.yindeterminate = true
      }
    })
    watch(
      () => state.drawerInfo.addressValidateConfigDetailDTOList,
      newVal => {
        newVal.forEach(i => {
          state.alreadySelectLanguage[i.type] = i.errorPromptDTOList.map(
            ii => ii.langCode
          )
        })
      },
      { deep: true }
    )
    provide('initState', state)
    onMounted(() => {
      state.getCountryList()
      state.getLanguage()
      state.getSiteInfo()
      state.getDeviceList()
      getLayerList()
      const route = useRoute()
      state.searchForm.type = route.query.type
      state.searchForm.status = route.query.status
      state.searchForm.id = route.query.id
      state.searchForm.name = route.query.name
      console.log(history.state.params, 990)
      if (history.state.params) {
        state.searchParams = history.state.params
      }
      state.getTableList()
      history.state.params = undefined
    })
    return {
      ...toRefs(state)
    }
  }
})
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
